import store from '@/store';
import utils from './../common/utils';
import client from './apiCommonConnector';

export default {
  async getAssignableToClient() {
    try {
      const rolesResponse = await client().get('/ambassador/clients/assignableroles');
      return rolesResponse.data.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des rôles assignables au client, veuillez réessayer.",
      });
      return [];
    }
  },

  async getAssignedToClient(clientId) {
    try {
      const rolesResponse = await client().get(`/ambassador/clients/${clientId}/roles`);
      return rolesResponse.data.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des rôles assignés au client, veuillez réessayer.",
      });
      return [];
    }
  },

  async getAssignableToContact(parentId) {
    try {
      const rolesResponse = await client().get(`/ambassador/clients/${parentId}/roles`);
      return rolesResponse.data.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des rôles assignables au contact, veuillez réessayer.",
      });
      return [];
    }
  },

  async getAssignedToContact(contactId) {
    try {
      const rolesResponse = await client().get(`/ambassador/contacts/${contactId}/roles`);
      return rolesResponse.data.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des rôles assignés au contact, veuillez réessayer.",
      });
      return [];
    }
  },

  async getAssignableToUser() {
    try {
      const rolesResponse = await client().get('/roles/assignableroles');
      return rolesResponse.data.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des rôles assignables à l'utilisateur, veuillez réessayer.",
      });
      return [];
    }
  },

  async getAssignedToUser(userId) {
    try {
      const rolesResponse = await client().get(`/users/${userId}/roles`);
      return rolesResponse.data.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des rôles assignés à l'utilisateur, veuillez réessayer.",
      });
      return [];
    }
  },

  async addToContact(roleId, contactId) {
    try {
      await client().post(`/ambassador/contacts/${contactId}/roles/${roleId}`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'ajout du rôle",
        detail: "Une erreur s'est produite lors de l'ajout du rôle au contact, veuillez réessayer.",
      });
      return false;
    }
  },

  async deleteFromContact(roleId, contactId) {
    try {
      await client().delete(`/ambassador/contacts/${contactId}/roles/${roleId}`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de la suppression du rôle',
        detail: "Une erreur s'est produite lors de la suppression du rôle, veuillez réessayer.",
      });
      return false;
    }
  },
  
  async addToUser(roleId, userId) {
    try {
      await client().post(`/users/${userId}/roles/${roleId}`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'ajout du rôle",
        detail: "Une erreur s'est produite lors de l'ajout du rôle à l'utilisateur, veuillez réessayer.",
      });
      return false;
    }
  },

  async deleteFromUser(roleId, userId) {
    try {
      await client().delete(`/users/${userId}/roles/${roleId}`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de la suppression du rôle',
        detail: "Une erreur s'est produite lors de la suppression du rôle, veuillez réessayer.",
      });
      return false;
    }
  },
  
  async addToClient(roleId, clientId) {
    try {
      await client().post(`/ambassador/clients/${clientId}/roles/${roleId}`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'ajout du rôle",
        detail: "Une erreur s'est produite lors de l'ajout du rôle au contact, veuillez réessayer.",
      });
      return false;
    }
  },

  async deleteFromClient(roleId, clientId) {
    try {
      await client().delete(`/ambassador/clients/${clientId}/roles/${roleId}`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de la suppression du rôle',
        detail: "Une erreur s'est produite lors de la suppression du rôle, veuillez réessayer.",
      });
      return false;
    }
  },

  async getHistoryForContact(partnerId, start = 0, size = 50) {
    try {
      const historyResponse = await client().get(`/ambassador/contacts/${partnerId}/roles/history?start=${start}&size=${size}`);
      const response = historyResponse.data;
      response.data = response.data.filter(hs => ['DELETE_RC_ROLE', 'INSERT_RC_ROLE'].includes(hs.role_history_action));
      return response;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération de l'historique des rôles, veuillez réessayer.",
      });
      return utils.createEmptyListResponse();
    }
  },

  async getHistoryForClient(partnerId, start = 0, size = 50) {
    try {
      const historyResponse = await client().get(`/ambassador/clients/${partnerId}/roles/history?start=${start}&size=${size}`);
      const response = historyResponse.data;
      response.data = response.data.filter(hs => ['DELETE_RC_ROLE', 'INSERT_RC_ROLE'].includes(hs.role_history_action));
      return response;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération de l'historique des rôles, veuillez réessayer.",
      });
      return utils.createEmptyListResponse();
    }
  },

  async getHistoryForUser(partnerId, start = 0, size = 50) {
    try {
      const historyResponse = await client().get(`/users/${partnerId}/roles/history?start=${start}&size=${size}`);
      const response = historyResponse.data;
      response.data = response.data.filter(hs => ['DELETE_RC_ROLE', 'INSERT_RC_ROLE'].includes(hs.role_history_action));
      return response;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération de l'historique des rôles, veuillez réessayer.",
      });
      return utils.createEmptyListResponse();
    }
  },
};
